import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionDto, AIActionUsageStatsResponseDto } from '@/Domain/api/Action/dto/Action.dto';
import { useSubscription } from '@/Domain/components/SubscriptionProvider';
import { ActionsPage } from '@/UI/Actions/Actions.page';

export const ActionsLoader = () => {
  const { isActivated, isFetched } = useSubscription();
  const isCampaignActivated = isActivated('campaigns');

  const { data, isLoading: isActionsLoading } = useQuery<ActionDto[]>({
    queryKey: [QueryKey.actions.basic.list],
  });

  const { data: statsData } = useQuery<AIActionUsageStatsResponseDto>({
    queryKey: [QueryKey.actions.basic.stats],
  });

  const { isLoading: isCampaignListLoading } = useQuery({
    queryKey: [QueryKey.campaign.list],
    enabled: isCampaignActivated,
  });

  const isReady =
    isFetched && !isActionsLoading && (!isCampaignActivated || !isCampaignListLoading);
  return isReady ? <ActionsPage actions={data!} stats={statsData?.stats} /> : null;
};
